import { data } from "jquery";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Platform } from "@ionic/angular";
import { GlobalsService } from "src/app/api/globals.service";
import { StorageService } from "src/app/services/storage.service";
import { TimerService } from "src/app/services/timer.service";

@Component({
  selector: "app-completa-espacio",
  templateUrl: "./completa-espacio.component.html",
  styleUrls: ["./completa-espacio.component.scss"],
})
export class CompletaEspacioComponent implements OnInit {
  @Input() public DATA: any;
  @Input() public curso: any;
  @Input() public ID_TIPO_LC: any;
  @Output() public isvalid = new EventEmitter<boolean>();
  @Output() public name = new EventEmitter<string>();
  private ID_TIPO = 3;
  private ID_ACTIVIDAD = 0;
  inicio_actividad_key: string;
  ismobile: boolean;
  private readonly table = "actividades_respuestas_data";
  constructor(
    private storageService: StorageService,
    private platform: Platform,
    public globalsService: GlobalsService,
    private timerService: TimerService
  ) {
    this.ismobile = globalsService.isMobile;
  }
  tablero: any = [];
  respuestas: any = [];
  public activityCourse: any;
  ngOnInit() {
    this.name.emit("Completa el espacio");
    let text = this.DATA.pregunta;
    this.ID_ACTIVIDAD = this.DATA.id_actividad;

    /******************* */
    let _id_librocurso = this.ID_ACTIVIDAD;
    let id_tipo = this.ID_TIPO;
    let id_ejercicio = this.DATA.id;
    let _id_curso = this.curso.id;
    let _tipo = this.ID_TIPO_LC;
    let _id_user = this.curso.id_user;
    const key = `inicio_actividad_${_id_curso}_${_id_librocurso}_${_id_user}_${_tipo}_${id_ejercicio}_${id_tipo}`;
    console.log("DATA ->KEY:", key);
    this.inicio_actividad_key = key;
    /******************* */

    let texto = text;
    let i = 0;
    let _this = this;
    let tokens: any = [];
    text.replace(/\[(.+?)\]/g, function (m, g1) {
      console.log("g1: ", g1);
      console.log("m: ", m);
      tokens.push(m);
    });
    let t: any = this.splitMulti(text, tokens);
    t.forEach((element, i) => {
      if (i < t.length - 1) {
        this.respuestas.push({ id: i, r: "" });
      }
    });
    this.tablero = t;

    this.platform.ready().then(() => {
      this.getStorage();
    });
  }
  async getStorage() {
    let activityCourse: any;
    this.storageService.get("activities").then((res: any) => {
      if (res) {
        activityCourse = res.find(
          (x) => x.id_actividad == this.ID_ACTIVIDAD && x.id == this.curso.id
        );
        activityCourse.data.forEach((element2, j) => {
          if (
            element2.id_tipo == this.DATA.id_tipo &&
            element2.id == this.DATA.id
          ) {
            let respuestas = element2.respuesta.r;
            respuestas.forEach((resp, j) => {
              this.respuestas[j].r = resp.r;
            });
            this.timerService.initTimer(element2.timer);
            this.isvalid.emit(true);
          }
        });

        this.isNextButtonDisabled();
      }
    });
  }

  splitMulti(str, tokens) {
    var tempChar = tokens[0]; // We can use the first token as a temporary join character
    for (var i = 1; i < tokens.length; i++) {
      str = str.split(tokens[i]).join(tempChar);
    }
    str = str.split(tempChar);
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].trim();
    }
    return str;
  }
  respuestasModel() {
    this.Storage(this.respuestas);
    this.isNextButtonDisabled();
  }
  Storage(respuesta: any) {
    //console.log("Respuesta:",respuesta);
    /************************************* */
    this.storageService
      .get("activities")
      .then((res) => {
        if (res) {
          this.activityCourse = res;
          this.activityCourse.forEach((element, i) => {
            if (
              element.id == this.curso.id &&
              element.id_actividad == this.ID_ACTIVIDAD
            ) {
              let data: any;
              data = {
                id: this.DATA.id,
                id_actividad: this.DATA.id_actividad,
                id_tipo: this.DATA.id_tipo,
                respuesta: {
                  r: respuesta,
                },
              };
              if (element.data.length == 0) {
                element.data.push(data);
              } else {
                let find: boolean = false;
                element.data.forEach((element2, j) => {
                  if (
                    element2.id_tipo == this.DATA.id_tipo &&
                    element2.id == this.DATA.id
                  ) {
                    element.data[j] = data;
                    find = true;
                  }
                });
                if (!find) {
                  element.data.push(data);
                }
              }
            }
          });
          this.storageService.storage("activities", this.activityCourse);
        } else {
          this.storageService.storage("activities", this.activityCourse);
        }
      })
      .catch((err) => {
        //this.storageService = null;
        console.log("storageService error", err);
      });
    /************************************* */
  }

  isNextButtonDisabled() {
    var valid = this.respuestas.some((item) => !item.r.trim());
    this.isvalid.emit(!valid);
  }
}
